<template>
  <div class="animated fadeIn">
  
    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3" v-if="can('tarification-create')">
          <router-link :to="'/tarifications/grilletarifaire/create/'+grilletarifaire_libelle">
            <b-button variant="primary" style="width:103px;height:40px;border-radius:0px;margin-right:2px;">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
      <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
        <div>
          <vue-good-table :columns="columns" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search" :totalRows="totalRecords" mode="remote" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange" @on-sort-change="onSortChange"
            @on-column-filter="onColumnFilter" >
            <template slot="table-row" slot-scope="props">
                              <span v-if="props.column.field == 'btn'">
            
                                    <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                                      <div role="group" aria-lableledby="header1">                   
                                          <router-link :to="'/tarifications/edit/' + props.row.id" v-if="can('tarification-edit')"><b-dropdown-item-button aria-describedby="header1" :id="props.row.id"><i class="fa fa-edit"></i> Modifier</b-dropdown-item-button></router-link>
                                          <!-- <b-dropdown-item-button aria-describedby="header1" v-if="can('tarification-delete')" @click.prevent="confirm()"><i class="fa fa-trash"></i> Désactiver</b-dropdown-item-button>
                                          <router-link :to="'/tarifications/show/' + props.row.id" v-if="can('tarification-list')"><b-dropdown-item-button aria-describedby="header1"><i class="fa fa-eye"></i> Plus d'infos</b-dropdown-item-button></router-link> -->
                                          <router-link :to="'/historique/tarification/'+ props.row.id">
                                            <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                                          </router-link>
                                      </div>
                                      
                                    </b-dropdown>
                                    <b-modal ref="myModalRef" hide-footer centered title="Confirmation de la désativation">
                                      <div class="d-block text-center">
                                        <p style>Etes vous certain de vouloir désactiver cette tarification ?</p>
                                        <h5>Voulez-vous continuer ?</h5>
                                      </div>
                                      <b-btn class="mt-3 col-lg-6" variant="outline-danger"  @click="cancel_delete">Annuler</b-btn>
                                      <b-btn class="mt-3 col-lg-6" variant="outline-success"  @click="post">Valider</b-btn>
                                    </b-modal>
                              </span>
                              <span v-else>
                                {{props.formattedRow[props.column.field]}}
                              </span>
</template>
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  //import cTableEntities from './TableEntities.vue'
  import {
    VueGoodTable
  } from 'vue-good-table';
  import {
    mapState,
    mapActions
  } from 'vuex';
  export default {
    name: 'tables',
    //components: {cTableEntities},
    components: {
      VueGoodTable
    },
    data() {
      return {
        totalRecords: 0,
        columns: [{
            label: 'Grille tarifaire',
            field: 'grilletarifaire_libelle',
            filterable: true,width: '180px',
            thClass: 'custom-th-class',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Montant minimum',
            field: 'montant_min',
            type: 'number',
            filterable: true,width: '180px',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Montant maximum',
            field: 'montant_max',
            type: 'number',
            filterable: true,width: '180px',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Tarif',
            field: 'tarif',
            type: 'number',
            filterable: true,width: '180px',
            thClass: 'custom-th-class',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
  
          {
            label: 'Enregistré le',
            field: 'created_at',
            type: 'date',
            dateInputFormat: 'YYYY-MM-DD',
            dateOutputFormat: 'YYYY-MM-DD',
            formatFn: this.formatFn,
            filterable: true,width: '180px',
            thClass: 'custom-th-class',
            filterOptions: {
              enabled: true, // enable filter for this column
              placeholder: 'Filter This Thing', // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              filterDropdownItems: [], // dropdown (with selected values) instead of text input
              filterFn: this.columnFilterFn, //custom filter function that
              trigger: 'keyup', //only trigger on enter not on keyup 
            },
          },
          {
            label: 'Action',
            field: 'btn',
            html: true,
            width: '150px',
          }
        ],
        rows: [],
        pagination: {
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3, 5, 10, 50, 100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search: {
          enabled: false,
          trigger: 'keyup',
          placeholder: 'Rechercher dans la table',
        },
        serverParams: {
          grilletarifaire_libelle: '',
          montant_min: '',
          montant_max: '',
          tarif: '',
          created_at: '',
          page: 1,
          current_page: 1,
          paginate: 10
        },
        grilletarifaire_libelle: ''
      };
    },
    // computed: mapState({
    //   agencies: state => state.atm.all
    // }),
    created() {
  
  
    },
    methods: {
      formatFn: function (value) {
          return value != null ? value : null
      },
      hideModal() {
        this.$refs.myModalRef.hide()
      },
      async cancel_delete() {
        this.hideModal()
      },
      async confirm() {
        this.$refs.myModalRef.show()
      },
      async get_all_tarifications() {
        this.$store.dispatch('tarification/get_all_tarifications').then(() => {
          return this.rows = store.getters['tarification/rows'];
        })
      },
      can(perm) {
        return store.getters['auth/can'](perm)
      },
      updateParams(newProps) {
        this.serverParams = Object.assign({}, this.serverParams, newProps);
      },
      onPageChange(params) {
        this.serverParams.page = params.currentPage
        this.updateParams({
          page: params.currentPage,
          current_page: params.currentPage
        });
        this.loadItems();
      },
      onPerPageChange(params) {
        this.serverParams.nb_lines = params.currentPerPage
        console.log(params)
        this.updateParams({
          page: params.currentPage,
          paginate: params.currentPerPage
        });
        this.loadItems();
      },
      onSortChange(params) {
        this.updateParams({
          sort: {
            type: params.sortType,
            field: this.columns[params.columnIndex].field,
          },
        });
        this.loadItems();
      },
      onColumnFilter(params) {
        this.serverParams.grilletarifaire_libelle = params.columnFilters.grilletarifaire_libelle,
        this.serverParams.montant_min = params.columnFilters.montant_min,
        this.serverParams.montant_max = params.columnFilters.montant_max,
        this.serverParams.tarif = params.columnFilters.tarif,
        this.serverParams.created_at = params.columnFilters.created_at,
          this.updateParams(params);
        this.loadItems();
      },
      // load items is what brings back the rows from server
      loadItems() {
        this.grilletarifaire_libelle = this.$route.params.grilletarifaire_libelle
        //console.log(this.$route.params.grilletarifaire_libelle)
        this.serverParams.grilletarifaire_libelle = this.$route.params.grilletarifaire_libelle
        this.$store.dispatch('tarification/get_all_tarifications_by_grille', this.serverParams).then((response) => {
          this.totalRecords = response.total;
          return this.rows = store.getters['tarification/rows'];
        })
      }
    },
    mounted() {
      //this.get_all_tarifications()
      this.loadItems()
    }
  
  }
</script>
